import { FileTextOutlined, WarningOutlined } from '@ant-design/icons';
import React, { ReactElement, useEffect } from 'react';

// Lazy Loading
const Case = React.lazy(() => import('Pages/Cases/Case'));
const Event = React.lazy(() => import('Pages/Events/EventDetail'));
const Cases = React.lazy(() => import('Pages/Cases/Cases'));
const CaseArchive = React.lazy(() => import('Pages/Archive/CaseArchive'));
const EventArchive = React.lazy(() => import('Pages/Archive/EventArchive'));
const UserSettingsPage = React.lazy(() => import('Pages/UserSettings'));
const ReportsPage = React.lazy(() => import('Pages/Reports/Reports'));

export type TARoute = {
  title?: string;
  key: string;
  component?: ReactElement;
  route: string;
  routeParam?: string[];
  icon?: React.ReactNode;
  items?: TARoute[];
};

// Used in Page Title and Navigation
// Template: {Product Name} {Page} {Type} {Id}
// Page Overrides for IDs are found in their respective places, Detection Case ID can be found in DetectionCaseDetail. Set the page in there.
///
const productName = 'MDR';
const PageTitle = props => {
  useEffect(() => {
    document.title = `${productName} ${props.title}`;
  }, [props.title]);

  return props.children;
};

export const locations: TARoute[] = [
  {
    route: 'case',
    key: 'case',
    component: (
      <PageTitle title="Case">
        <Case />
      </PageTitle>
    ),
    routeParam: ['caseType', 'caseId']
  },
  {
    route: 'event',
    key: 'event',
    component: (
      <PageTitle title="Event">
        <Event />
      </PageTitle>
    ),
    routeParam: ['eventId']
  },
  {
    title: 'Cases',
    route: 'cases',
    key: 'cases',
    icon: <WarningOutlined />,
    component: (
      <PageTitle title="Cases">
        <Cases />
      </PageTitle>
    ),
    routeParam: ['activeTab', 'caseId']
  },
  {
    title: 'Data',
    route: 'data',
    key: 'data',
    icon: <FileTextOutlined />,
    items: [
      {
        title: 'Reports',
        route: 'reports',
        key: 'reports',
        component: (
          <PageTitle title="Reports">
            <ReportsPage />
          </PageTitle>
        )
      },
      {
        title: 'Archive',
        key: 'archive',
        route: 'archive',
        items: [
          {
            title: 'Events',
            key: 'archive-secEvent',
            route: 'events',
            component: (
              <PageTitle title="Case Archive">
                <EventArchive />
              </PageTitle>
            )
          },
          {
            title: 'Cases',
            key: 'archive-cases',
            route: 'cases',
            component: (
              <PageTitle title="Case Archive">
                <CaseArchive />
              </PageTitle>
            )
          }
        ]
      }
    ]
  },
  {
    key: 'userSettings',
    route: 'account',
    component: (
      <PageTitle title="User Settings">
        <UserSettingsPage />
      </PageTitle>
    )
  }
];
